'use client'
import React from 'react'
import { SearchIcon } from '@/shared/Icons'
import SearchModalBox from '@/shared/components/search'
import DarkModeButton from '../../darkModeButton'
import useModal from '@/shared/hooks/useModal'
import GetApp from '../../get-app'

export default function SearchModal() {
  const { isOpen, setIsOpen, onClose } = useModal()

  return (
    <>
      <div className='flex items-center gap-0.5 md:gap-2 ml-auto'>
        <DarkModeButton />
        <GetApp />
        <div
          className='cursor-pointer dark:brightness-0 dark:invert-[1] hidden md:block'
          onClick={() => setIsOpen(true)}
        >
          <SearchIcon />
        </div>
      </div>
      <div className='hidden md:block'>
        {isOpen && <SearchModalBox isOpen={isOpen} onClose={onClose} />}
      </div>
    </>
  )
}
